import { useTheme } from "../theme/ThemeProvider";

/**
 * The canonical **elabor8** wordmark — ONE source of truth for the brand mark
 * shown across the app: the sidebar home affordance ({@link SidebarLogo}), the
 * login hero, and the workspace picker. Previously each surface diverged (the
 * sidebar used this SVG while login/picker rendered a plain "elaborate"
 * text wordmark); this component unifies them.
 *
 * The wordmark ships as two theme variants; the resolved theme picks the right
 * one via {@link useTheme} — the same JS-driven mechanism the workspace switcher
 * uses to pick its accent (never a hardcoded colour). The SVGs are served
 * statically from `public/logos/*` so bundling stays plain. A compact sygnet
 * ships alongside at `/logos/elabor8-sygnet-logo.svg` for a future collapsed rail.
 */

export const BRAND_FULL_LOGO: Record<"light" | "dark", string> = {
  light: "/logos/elabor8-full-logo-light.svg",
  dark: "/logos/elabor8-full-logo-dark.svg",
};

export function BrandWordmark({
  className,
  height = 22,
  testId,
}: {
  className?: string;
  height?: number;
  testId?: string;
}) {
  const { resolved } = useTheme();
  return (
    <img
      className={className}
      src={BRAND_FULL_LOGO[resolved]}
      alt="elabor8"
      data-theme-variant={resolved}
      data-testid={testId}
      height={height}
      draggable={false}
    />
  );
}
